<template>
  <div class="detail-footer" v-if="show != 'false'">
    <div class="detail-footer-update">
      <div v-if="status == 0" class="ft ft_sh">
        <div class="fl fl1">
          <p>您提交的项目正在审核中</p>
        </div>
        <van-button
          :class="[
            'btn3 btn31',
            { update_fcR2: status == 1 },
            { update_fcR: status == 2 },
            { update_fcR1: status == 0 },
          ]"
          type="info"
          native-type="submit"
          @click="onSubmit"
          >修改</van-button
        >
      </div>
      <div v-if="status == 1" class="ft ft_sh ft_sh3">
        <div class="fl">
          <p>您提交的信息已通过审核，并计入统计结果</p>
        </div>
        <van-button
          :class="[
            'btn3',
            { update_fcR2: status == 1 },
            { update_fcR: status == 2 },
            { update_fcR1: status == 0 },
          ]"
          type="info"
          native-type="submit"
          @click="onSubmit"
          >修改</van-button
        >
      </div>
      <div v-if="status == 2" class="ft ft_sh ft_sh2">
        <div class="fl">
          <p>抱歉，您提交的信息未通过审核，请重新填报</p>
        </div>
        <van-button
          :class="[
            'btn3',
            { update_fcR2: status == 1 },
            { update_fcR: status == 2 },
            { update_fcR1: status == 0 },
          ]"
          type="info"
          native-type="submit"
          @click="onSubmit"
          >修改</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "divFooter",
  props: {
    status: {
      type: Number,
      default: -1,
    },
    isShow: {
      type: Boolean,
      default: true,
    },
    formId: {
      type: Number,
    },
    id: {
      type: String,
    },
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const { isShow } = route.query;
    const show = isShow ? isShow : props.isShow;
    const state = reactive({
      show: show,
    });
    const onSubmit = () => {
      // type 1 修改
      router.push({
        path: "/info/add/form" + props.formId,
        query: { type: 1, id: props.id },
      });
    };
    return {
      ...toRefs(state),
      onSubmit,
    };
  },
};
</script>
<style lang="less" scoped>
@import "../common/style/mixin";
.detail {
  height: 100%;
  &-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px; /* 底部高度 */
    line-height: 50px;
    color: @primary;
    font-size: 16px;
    background: #fff;
    max-width: 640px;
  }
  &-footer-update {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
  }
  .van-button--round {
    border-radius: 0;
    height: 50px; /* 底部高度 */
    line-height: 50px;
    width: 100px;
  }
}
.fl1 {
  color: #ff8683 !important;
}
.btn31 {
  background: #ff8683 !important;
}
</style>
